import getActionsByDocument from '../../../../../components/comments/actions';

const DOCUMENT = 'COMPANY_COMMENTS_';

export default getActionsByDocument(DOCUMENT);
